import {
  createLpCapitalActionNoticeCreateRoute,
  LP_CAPITAL_ACTION_LIST,
} from 'adminConstants/routes';
import SuccessPage from 'components/new/SuccessPage';
import { useHistory, useParams } from 'react-router-dom';

const Success: React.FC = () => {
  const history = useHistory();
  const { id } = useParams<{ id?: string }>();

  if (!id) {
    throw new Error('Capital action not found.');
  }

  const handleContinue = () => {
    history.push(createLpCapitalActionNoticeCreateRoute(id));
  };

  const handleDoThisLater = () => {
    history.push(LP_CAPITAL_ACTION_LIST);
  };

  return (
    <SuccessPage
      title="Capital action has been processed successfully"
      content="Your capital action has been processed, and your capital action notices are ready to be created."
      primaryButton={{
        label: 'Create capital action notices',
        onClick: handleContinue,
      }}
      secondaryButton={{
        label: 'Do this later',
        onClick: handleDoThisLater,
      }}
    />
  );
};

export default Success;
